
export default {
  name: "xcoinTerms",
  layout: "DefaultLayout",
  head() {
    return {
      title: "X-Coins User Agreement",
    };
  },
};
